import {
  AuthState,
  AuthActionTypes,
  LOG_IN_REQ,
  LOG_IN_RES,
  FAILED_REQUEST,
  LOAD_TOKEN_REQ,
  LOAD_TOKEN_RES,
  LOG_OUT_REQ,
  LOG_OUT_RES,
} from './types';

const initialState: AuthState = {
  authenticated: false,
  loading: false,
};

export function authReducer(state = initialState, action: AuthActionTypes): AuthState {
  switch (action.type) {
    case LOAD_TOKEN_REQ:
      return { ...state, loading: true };
    case LOAD_TOKEN_RES:
      return {
        ...state,
        authenticated: !!action.payload,
        personId: action.payload?.personId,
        personFirstName: action.payload?.fName,
        personLastName: action.payload?.lName,
        personRoles: action.payload?.roles,
        loading: false,
      };
    case LOG_IN_REQ:
      return { ...state, loading: true };
    case LOG_IN_RES:
      return {
        ...state,
        authenticated: !!action.payload,
        personId: action.payload?.personId,
        personFirstName: action.payload?.fName,
        personLastName: action.payload?.lName,
        personRoles: action.payload?.roles,
        loading: false,
      };
    case LOG_OUT_REQ:
      return { ...state, loading: true };
    case LOG_OUT_RES:
      return { ...initialState };
    case FAILED_REQUEST:
      return { ...state, loading: false };
    default:
      return state;
  }
}
